export type UploadRequest = {
  /** Подписанная ссылка хранилища из presign. Её нельзя писать в логи и отчёты об ошибках. */
  url: string;
  method: string;
  /** Заголовки из presign: подпись ссылки их учитывает, поэтому уходят все и без изменений. */
  headers: Record<string, string>;
  body: Blob;
  /** Доля отправленного, от 0 до 1. */
  onProgress: (fraction: number) => void;
};

/** Хранилище ответило не 2xx: например, подписанная ссылка истекла. */
export class UploadError extends Error {
  constructor(readonly status: number) {
    super(`Upload failed with HTTP ${status}`);
    this.name = "UploadError";
  }
}

/**
 * Загрузка файла по подписанной ссылке прямо в хранилище, мимо API. Ошибка — `UploadError` со статусом
 * или `TypeError`, если запрос не дошёл (как у fetch). В тестах подменяется фейковым backend'ом.
 */
export type FileUploader = (request: UploadRequest) => Promise<void>;

/** XMLHttpRequest, а не fetch: только он сообщает о прогрессе отправки тела запроса. */
export function createFileUploader(): FileUploader {
  return ({ url, method, headers, body, onProgress }) =>
    new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(method, url);
      for (const [name, value] of Object.entries(headers)) request.setRequestHeader(name, value);
      request.upload.onprogress = (event) => {
        if (event.lengthComputable) onProgress(event.loaded / event.total);
      };
      request.onload = () => {
        if (request.status >= 200 && request.status < 300) resolve();
        else reject(new UploadError(request.status));
      };
      request.onerror = () => reject(new TypeError("Upload failed"));
      request.send(body);
    });
}
